import type { EmbarcacaoConsumoOperacaoField } from "@/modules/embarcacoes";
import { formatDetailDate, formatDetailDecimalText } from "../../../detail-format/detail-format";
import type { DetailFieldDefinition } from "../../../detail-format/detail-fields";

export const CONSUMO_OPERACAO_ID = "consumo-operacao";
export const CONSUMO_OPERACAO_TITLE = "Consumo Modo Operação";
export const CONSUMO_OPERACAO_TEST_ID = "embarcacao-consumo-operacao";
export const CONSUMO_OPERACAO_LOADING_MESSAGE =
  "Carregando o Consumo Modo Operação da embarcação...";

/** Padrão global de estado vazio do Hub para a seção sem informações. */
export const CONSUMO_OPERACAO_EMPTY_STATE = {
  title: "Nenhuma informação de Consumo Modo Operação disponível",
  description:
    "Assim que houver dados de consumo para esta embarcação, eles aparecerão nesta seção.",
};

/** Unidade de todos os consumos da seção (RN002). */
const CONSUMO_UNIT = "m³/dia";

/**
 * Os 7 campos do corpo da seção, na ordem do protótipo (AC2). O grid os
 * distribui em duas colunas, par a par. A última atualização acompanha o
 * título, como nas demais seções.
 */
export const CONSUMO_OPERACAO_FIELDS: readonly DetailFieldDefinition<EmbarcacaoConsumoOperacaoField>[] =
  [
    { key: "consumoDp", label: `Consumo DP (${CONSUMO_UNIT})`, format: formatDetailDecimalText },
    {
      key: "consumoFdAt",
      label: `Consumo FD/AT (${CONSUMO_UNIT})`,
      format: formatDetailDecimalText,
    },
    {
      key: "consumoNvVelServico",
      label: `Consumo NV em Vel. Serviço (${CONSUMO_UNIT})`,
      format: formatDetailDecimalText,
    },
    {
      key: "consumoNvVelTotal",
      label: `Consumo NV em Vel. Total (${CONSUMO_UNIT})`,
      format: formatDetailDecimalText,
    },
    { key: "consumoSm", label: `Consumo SM (${CONSUMO_UNIT})`, format: formatDetailDecimalText },
    {
      key: "consumoNvVelEconomica",
      label: `Consumo NV em Vel. Econômica (${CONSUMO_UNIT})`,
      format: formatDetailDecimalText,
    },
    { key: "atualizacaoConsumo", label: "Data Atualização Consumo", format: formatDetailDate },
  ];
